import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categoryName: string;
  author: string;
  date: string;
  readTime: string;
  image: string;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  category,
  categoryName,
  author,
  date,
  readTime,
  image,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/50 hover:border-primary-200 transition-all duration-300 overflow-hidden">
      <Link to={`/article/${slug}`} className="block cursor-pointer">
        <div className="relative aspect-[16/9] overflow-hidden">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            title={title}
          />
          <div className="absolute top-3 left-3">
            <Link
              to={`/category/${category}`}
              className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-background-50/90 text-primary-700 hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              {categoryName}
            </Link>
          </div>
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <Link to={`/article/${slug}`} className="block cursor-pointer">
          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
          {excerpt}
        </p>
        <div className="flex items-center gap-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {readTime}
          </span>
        </div>
      </div>
    </article>
  );
}